"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _PLink = _interopRequireDefault(require("kether-shared-lib/PLink"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FLink = /* <N, O>  */function FLink(_ref) {
  var className = _ref.className,
    id = _ref.id,
    kind = _ref.kind,
    text = _ref.text,
    action = _ref.action;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PLink["default"], {
    className: "".concat(!!className ? "".concat(className, " ") : ''),
    id: id,
    kind: kind,
    text: text,
    action: action
  });
};
var _default = FLink;
exports["default"] = _default;